import PlaceTokens from "@/utils/constants/PlaceTokens.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import ListPlace from "@/utils/presenters/ListPlace.ts";
import Translator from "@/utils/common/Translator.ts";
import ClientCache from "@/utils/login/ClientCache.ts";
import RouteNames from "@/router/RouteNames.ts";
import FieldActionContextInfo = namaTypes.FieldActionContextInfo;
import BaseEntityDTO = namaTypes.BaseEntityDTO;

export default class EditPlace extends ListPlace {
  private _quickCreateContextInfo?: FieldActionContextInfo | null = null;
  private _reNavigateToObject: namaTypes.BaseEntityDTO | undefined = undefined;

  static createInstance(entityType: string, id: string | undefined, edit: string, query?: Record<string, string>) {
    let editPlace = new EditPlace({});
    if (query)
      editPlace.setParameters(query)
    editPlace.id = id;
    editPlace.entityType = entityType;
    editPlace.view = edit;
    return editPlace;
  }

  override shouldResetEditViewParams() {
    return false;
  }
  get tabId(): string | undefined {
    return this. query[PlaceTokens.PRM_TAB_ID];
  }

  set tabId(value: string | undefined) {
    this. query[PlaceTokens.PRM_TAB_ID] = value;
  }

  get fieldValues(): string | undefined {
    return this.query[PlaceTokens.PRM_FIELDS] ;
  }

  set fieldValues(value: string | undefined) {
    this.query[PlaceTokens.PRM_FIELDS]  = value;
  }

  get focusOnField(): string | undefined {
    return this.query[PlaceTokens.PRM_FOCUS_ON_FIELD];
  }

  set focusOnField(value: string | undefined) {
    this.query[PlaceTokens.PRM_FOCUS_ON_FIELD] = value;
  }

  get templateId(): string | undefined {
    return this.query[PlaceTokens.PRM_EDIT_TEMPLATE_ID];
  }

  set templateId(value: string | undefined) {
    this.query[PlaceTokens.PRM_EDIT_TEMPLATE_ID] = value;
  }

  get version(): number | undefined {
    let version = this.query[PlaceTokens.PRM_VERSION];
    return version ? Number.parseInt(version) : undefined
  }

  set version(value: number | undefined) {
    this.query[PlaceTokens.PRM_VERSION] = value ? value + '' : undefined;
  }

  get quickCreateRequester(): string | undefined {
    return this.query[PlaceTokens.PRM_QUICKCREATE_REQUESTER];
  }

  set quickCreateRequester(value: string | undefined) {
    this.query[PlaceTokens.PRM_QUICKCREATE_REQUESTER] = value;
  }

  get quickCreate(): boolean | undefined {
    return ObjectChecker.valueOfBoolean(this.query[PlaceTokens.PRM_QUICKCREATE]) ?? false
  }

  set quickCreate(value: boolean | undefined) {
    this.query[PlaceTokens.PRM_QUICKCREATE] = value ? value + '' : undefined;
  }

  get pageId(): number | undefined {
    const pageIdAsString = this.query[PlaceTokens.PRM_PAGE_ID] + '';
    const pageId = Number.parseInt(pageIdAsString);
    if (isNaN(pageId))
      return undefined
    else
      return pageId;
  }

  set pageId(value: number | undefined) {
    this.query[PlaceTokens.PRM_PAGE_ID] = ObjectChecker.isNotNullOrUndefined(value) ? value + '' : undefined;
  }

  get editViewName(): string | undefined {
    return this.query[PlaceTokens.PRM_EDIT_VIEW_NAME];
  }

  set editViewName(value: string | undefined) {
    this.query[PlaceTokens.PRM_EDIT_VIEW_NAME] = value;
  }

  get view(): string | undefined {
    return this.query[PlaceTokens.PRM_VIEW];
  }

  set view(value: string | undefined) {
    this.query[PlaceTokens.PRM_VIEW] = value;
  }

  get id(): string | undefined {
    return this.query[PlaceTokens.PRM_ID];
  }

  set id(value: string | undefined) {
    this.query[PlaceTokens.PRM_ID] = value;
  }

  get code(): string | undefined {
    return this.query[PlaceTokens.PRM_CODE];
  }

  set code(value: string | undefined) {
    this.query[PlaceTokens.PRM_CODE] = value;
  }

  get quickCreateContextInfo(): FieldActionContextInfo | null | undefined {
    return this._quickCreateContextInfo;
  }

  set quickCreateContextInfo(value: FieldActionContextInfo | null | undefined) {
    this._quickCreateContextInfo = value;
  }

  calcEditViewName(): string | undefined {
    return ObjectChecker.getFirstNotEmptyObj(this.editViewName, this.listViewName);
  }

  get reNavigateToObject(): BaseEntityDTO | undefined {
    return this._reNavigateToObject;
  }

  set reNavigateToObject(value: BaseEntityDTO | undefined) {
    this._reNavigateToObject = value;
  }

  get createdObjectId(): string | undefined {
    return this.query[PlaceTokens.PRM_CREATED_OBJECT_ID];
  }

  set createdObjectId(value: string | undefined) {
    this.query[PlaceTokens.PRM_CREATED_OBJECT_ID] = value;
  }

  static cloneFrom(oldPlace: EditPlace): EditPlace {
    let place:EditPlace = new EditPlace();
    if (!oldPlace || !oldPlace.fetchQuery())
      return place;
     place.setParameters(oldPlace.fetchQuery());
    return place;
  }

  override getTitleForWindow(): string {
    return  Translator.getDetailsViewTitlePrefix(this.entityType, ClientCache.getMenuLineBySrc(this.src));
  }

  override getRouteName(): string | null {
    return RouteNames.EDIT_VIEW_ROUTE;
  }
}
